<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <form autocomplete="off" [formGroup]="formHeader">
      <div class="row filtros-body">

        <div class="col dato" style="max-width: 300px">
          <div class="md-form">
            <input value="" type="text" id="descRecorrido" class="form-control" placeholder="Código" onlyNumbers
              formControlName="codigoRecorrido" autocomplete="off" />
            <label for="descRecorrido">Código de recorrido</label>
          </div>
        </div>
        <!-- <div class="col dato" style="max-width: 300px">
          <div class="md-form">

            <input value="" type="text" id="descRecorrido" class="form-control" placeholder="Chofer" formatRut
              formControlName="chofer" />
            <label for="descRecorrido">Chofer</label>
          </div>
        </div> -->
        <div class="col dato" style="max-width: 300px">
          <div class="md-form">

            <input value="" type="text" id="descRecorrido" class="form-control" placeholder="Chofer"
              formControlName="choferNombre" />
            <label for="descRecorrido">Nombre de Chofer</label>
          </div>
        </div>
        <div class="col dato" style="max-width: 300px">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fecha" [placeholder]="'Fecha salida'" formControlName="fecha"
              #dpFecha>
            </mdb-date-picker>
          </div>
        </div>

        <div class="col dato" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsEstado" formControlName="listaEstado" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Estado"></mdb-select>
            <label>Estado</label>
          </div>
        </div>

      </div>

    </form>
  </div>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
    <div>
      <button mdbBtn type="button" color="success" size="sm" mdbWavesEffect [disabled]="!recorridoEnviar"
        (click)="iniciarLiquidacion()">
        Iniciar liquidación
      </button>
    </div>
    <div>
      <button mdbBtn type="button" color="info" size="sm" mdbWavesEffect (click)="limpiarfiltros()">
        <mdb-icon fas icon="broom"></mdb-icon>
        Limpiar
      </button>

      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>

  </div>
</div>

<div class="card mb-2 wow" *ngIf="HiddeTable == false">
  <div class="card-body">

    <!-- <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner> -->

    <div class="">

      <table class="table table-striped table-hover table-sm align-middle mt-1" *ngIf="listaRecorridos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Código</th>
            <th scope="col">Fecha</th>
            <th scope="col">Patente</th>
            <th scope="col">Chofer</th>
            <th scope="col">Hora de salida</th>
            <th scope="col">Monto recorrido</th>
            <th scope="col">Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!loading && listaRecorridos?.length === 0">
            <td colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let recorrido of listaRecorridos; let i = index" (click)="ClickedRow(i, recorrido)"
            [class.active]="i == HighlightRow">
            <td>{{recorrido.codigo}}</td>
            <td>{{recorrido.fecha | fecha}}</td>
            <td>{{recorrido.camion_patente}}</td>
            <td>{{recorrido.rutChoferFormato | rut}}</td>
            <td>{{recorrido.fecha_hora_salida | date:'HH:mm'}}</td>
            <td>{{recorrido.total_documentos | numerico}}</td>
            <td>
              <mdb-badge *ngIf="recorrido.codigo_estado === 1" pill="true" info="true">{{ recorrido.nombre_estado }}</mdb-badge>
              <mdb-badge *ngIf="recorrido.codigo_estado === 2" pill="true" warning="true">{{ recorrido.nombre_estado }}</mdb-badge>
              <mdb-badge *ngIf="recorrido.codigo_estado === 3" pill="true" success="true">{{ recorrido.nombre_estado }}</mdb-badge>
            </td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaRecorridos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<app-modal-seleccionar-recorrido-liquidacion (onSelect)="onRecorridoSeleccionado($event)"
  (onNotFound)="onNotFoundRecorrido()">
</app-modal-seleccionar-recorrido-liquidacion>
